module.exports = __webpack_public_path__ + "img/img-parts-sishu01.068beeb3.png";